export const constants = {
  TERMS_AND_CONDITIONS_ENDPOINT: '/api/sign-in-service/v1/sign-in.challenge.respond',
};
